import type { FC } from "react";

import { Button } from "@jti/core-components/components/Button";
import { DEPRECATED_Loading } from "@jti/ui/components/DEPRECATED_Loading";

import styles from "./RedeemDialogButtons.module.scss";

export type RedeemDialogButtonsProps = {
  primaryCtaLabel: string;
  secondaryCtaLabel: string;
  handleCloseDialog: () => void;
  handleRedeemPrize: () => void;
  isQueryInProgress: boolean;
};

export const RedeemDialogButtons: FC<RedeemDialogButtonsProps> = ({
  primaryCtaLabel,
  secondaryCtaLabel,
  handleCloseDialog,
  handleRedeemPrize,
  isQueryInProgress,
}) => {
  return (
    <div className={styles.container} data-testid="redeemDialogButtonsRow">
      {isQueryInProgress ? (
        <DEPRECATED_Loading dataTestId="redeemDialogQueryInProgress" />
      ) : (
        <>
          <Button onClick={handleCloseDialog} variant="secondary">
            {secondaryCtaLabel}
          </Button>
          <Button onClick={handleRedeemPrize}>{primaryCtaLabel}</Button>
        </>
      )}
    </div>
  );
};
